import { type PaletteMode, type ThemeOptions } from '@mui/material';
import { type Tokens } from '@zeus/themes';

export function createPalette(tokens: Tokens): ThemeOptions['palette'] {
  return {
    accent: tokens.palette['accent'],
    action: tokens.palette['action'],
    background: tokens.palette['background'],
    brand: tokens.palette['brand'],
    common: tokens.palette['common'],
    divider: tokens.palette['divider'],
    error: tokens.palette['error'],
    forceWhite: tokens.palette['forceWhite'],
    grey: tokens.palette['grey'],
    info: tokens.palette['info'],
    mode: tokens.palette?.mode as PaletteMode | undefined,
    primary: tokens.palette['primary'],
    secondary: tokens.palette['secondary'],
    success: tokens.palette['success'],
    text: tokens.palette['text'],
    warning: tokens.palette['warning'],
  };
}
